import { queryOptions, useQuery } from "@tanstack/react-query";
import { API_HOST } from "../App";
import { z } from "zod";

const locationInfoSchema = z.object({
  name: z.string(),
  cvr: z.string(),
  openingHours: z.array(z.object({
    startDay: z.string(),
    startHour: z.string(),
    closeDay: z.string(),
    closeHour: z.string(),
  })),
  defaultOnPremiseDeliveryMethod: z
    .enum(["TABLE_SERVICE", "PICKUP_AT_COUNTER"])
    .optional()
    .nullable(),
});

export type LocationInfo = z.infer<typeof locationInfoSchema>;

export const locationInfoQueryOptions = (locationId: string) =>
  queryOptions({
    queryKey: ["locationInfo", locationId],
    queryFn: async () => {
      const response = await fetch(`${API_HOST}/v1/locations/${locationId}/info`);
      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(`Failed to fetch location info: ${response.status}`);
      }
      
      try {
        return locationInfoSchema.parse(data);
      } catch (error) {
        console.error("Error parsing location info:", error);
        if (error instanceof z.ZodError) {
          console.log(error.issues);
        }
        throw new Error("Error when parsing location info - please contact support");
      }
    },
  });

export const useLocationInfo = (locationId: string) => {
  return useQuery(locationInfoQueryOptions(locationId));
};